@layer module {
.recurring-details-compound-row {
            width: 100%;
            border-bottom-width: 1px;
            border-bottom-style: solid;
    }

.recurring-details-compound-row:last-child {
            border-bottom: none;
    }

.recurring-details-compound-row .value {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
    }

.recurring-details-compound-row .pair {
            display: inline-flex;
            flex-wrap: wrap;
    }
} // layer module










@layer app {
.recurring-details-compound-row {
            padding: $size-10 0;
    }

.recurring-details-compound-row:last-child {
            padding-bottom: 0;
    }

.recurring-details-compound-row .label {
            margin-bottom: $size-4;
    }

.recurring-details-compound-row .value {
            gap: $size-2 $size-6;
    }

.recurring-details-compound-row .pair {
            column-gap: $size-6;
    }

.recurring-details-compound-row {
            border-bottom-color: var(--border-default);
            font-size: var(--font-size-base);
    }

.recurring-details-compound-row .label {
            font-size: var(--font-size-sm);
            font-weight: 600;
            color: var(--label-value-key-text);
    }

.recurring-details-compound-row .value {
            color: var(--label-value-value-text);
    }

.recurring-details-compound-row .arrow {
            color: var(--text-secondary);
    }
} // layer app
